/** Formats optional list-level `lastSyncedAt` from GET list APIs. */
export function formatLastSyncedAtLabel(
	iso: string | undefined,
	formatTimestamp: (value: string) => string,
): string | null {
	const value = iso?.trim();
	if (!value) return null;
	return `Last synced: ${formatTimestamp(value)}`;
}

/** Audit fields from API may be null (e.g. SevenRooms sync). */
export function formatAuditUserLabel(value: unknown): string {
	if (value == null || value === "") return "—";
	const trimmed = String(value).trim();
	return trimmed || "—";
}
